module.exports = __webpack_public_path__ + "static/media/24_tn.46e63cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/24_tn.jpg
// module id = 238
// module chunks = 0